export default "__VITE_ASSET__orlvahMH__"